import { BUSCAR_USUARIOS_VENDEDORES, LIMPAR_USUARIOS_VENDEDORES } from '../../actions/types'

const initialState = undefined

export default function reducerUsuariosVendedores (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_USUARIOS_VENDEDORES: {
      const vendedores = action.payload.data;

      if (vendedores) {
        return vendedores
      }
      return []
    }
    case LIMPAR_USUARIOS_VENDEDORES:
      return []

    default: {
      return state
    }
  }
}
